import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import AuthContext from "context/AuthContext";
import PersonalDetails from "./personalDetails/PersonalDetails";
import Subscription from "./subscriptionDetails/Subscription";
import SecuritySettings from "./securitySettings/SecuritySettings";
// GEO ACCESS: 4th Edit profile tab — company IP lists + Google map from IP lookup
import GeographicAccess from "./geographicAccess/GeographicAccess";
import { MFAProvider } from "context/MFAContext";

const tabBtnClass =
  "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-blue-600 text-blue-600";
const tabBorderNoneClass = "border-transparent";
const TAB_PERSONAL = "personalDetail";
const TAB_SUBSCRIPTION = "subscriptionDetail";
const TAB_SECURITY = "securitySettings";
// const previous tabs only — GEO ACCESS added below
const TAB_GEO = "geographicAccess";

const Profile = () => {
  const { t } = useTranslation();
  const { updatePageName } = useContext(AuthContext);
  const [defaultTab, setDefaultTab] = useState("personalDetail");
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };

  useEffect(() => {
    updatePageName(t("EDIT_PROFILE"));
  }, []);

  let tabContent = null;
  if (defaultTab === TAB_PERSONAL) {
    tabContent = <PersonalDetails />;
  } else if (defaultTab === TAB_SUBSCRIPTION) {
    tabContent = <Subscription />;
  } else if (defaultTab === TAB_SECURITY) {
    tabContent = <SecuritySettings />;
  } else if (defaultTab === TAB_GEO) {
    tabContent = <GeographicAccess />;
  }

  return (
    <MFAProvider>
      <div className="py-5 px-9">
        <div className="py-3 my-2">
          <ul className="border-b flex">
            <li className="mr-0 xl:mr-5">
              <button
                onClick={handleTabClick.bind(this, TAB_PERSONAL)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_PERSONAL,
                  [tabBorderNoneClass]: defaultTab !== TAB_PERSONAL,
                })}
              >
                {t("PERSONAL_DETAILS")}
              </button>
            </li>
            <li className="mx-0 xl:mx-5">
              <button
                onClick={handleTabClick.bind(this, TAB_SUBSCRIPTION)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_SUBSCRIPTION,
                  [tabBorderNoneClass]: defaultTab !== TAB_SUBSCRIPTION,
                })}
              >
                {t("SUBSCRIPTION_DETAILS")}
              </button>
            </li>
            <li className="mx-0 xl:mx-5">
              <button
                onClick={handleTabClick.bind(this, TAB_SECURITY)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_SECURITY,
                  [tabBorderNoneClass]: defaultTab !== TAB_SECURITY,
                })}
              >
                {t("SECURITY_SETTINGS")}
              </button>
            </li>
            <li className="mx-0 xl:mx-5">
              <button
                onClick={handleTabClick.bind(this, TAB_GEO)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_GEO,
                  [tabBorderNoneClass]: defaultTab !== TAB_GEO,
                })}
              >
                {t("GEOGRAPHIC_ACCESS")}
              </button>
            </li>
          </ul>
        </div>

        {tabContent}
      </div>
    </MFAProvider>
  );
};

export default Profile;